import PropTypes from "prop-types";

export const SimpleHeaderPropTypes = {
    onBackClick: PropTypes.func,
    rightSide: PropTypes.node,
    showArrow: PropTypes.bool,
    backText: PropTypes.string,
    showBack: PropTypes.bool,
};
